import { styled } from '@mui/material/styles';
import { HexColorPicker } from 'react-colorful';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';

const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    position: 'absolute',
    bottom: '10%'
  }
});

const MessageBox = styled('div')({
  whiteSpace: 'pre-line',
  textAlign: 'center',
  fontSize: 16,
  color: '#333',
  marginBottom: 20,
  '& .react-colorful': {
    width: 200,
    height: 200
  }
});

const CloseButton = styled(IconButton)({
  position: 'absolute',
  top: 5,
  right: 5
});

interface ColorPickerProps {
  open: boolean;
  color: string;
  setIndex: (index: number | null) => void;
  onColorChange: (color: string) => void;
  onClose: () => void;
}

export default function ColorPicker({ open, color, setIndex, onColorChange, onClose }: ColorPickerProps) {
  const handleChangeColor = (newColor: string) => {
    onColorChange(newColor);
  };

  const handleClose = () => {
    setIndex(null);
    onClose();
  };

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="color-picker-dialog"
      slotProps={{
        backdrop: {
          invisible: true
        }
      }}
    >
      <DialogContent>
        <MessageBox>
          <CloseButton aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </CloseButton>
          <HexColorPicker color={color} onChange={handleChangeColor} />
        </MessageBox>
      </DialogContent>
    </StyledDialog>
  );
}
